import React, { FC } from 'react'
import { FormCheckProps } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import 'bootstrap/dist/css/bootstrap.min.css'
import './Checkbox.css'

interface CheckboxProps extends FormCheckProps {
  label?: string | JSX.Element
  checked?: boolean
  required?: boolean
  controlId?: string
  id?: string
  onChangeHandler?: (value: React.ChangeEvent<HTMLInputElement>) => void
}
const Checkbox: FC<CheckboxProps> = ({
  label,
  className,
  checked,
  required,
  controlId,
  id,
  onChangeHandler,
  ...rest
}) => {
  return (
    <Form.Group className={`${className} align-text`} controlId={controlId}>
      <Form.Check
        type="checkbox"
        // label={label}
        checked={checked}
        required={required}
        onChange={onChangeHandler}
        id={id}
        {...rest}
      />
      <label style={{ marginLeft: '10px', marginTop: '5px' }}>{label}</label>
    </Form.Group>
  )
}

export default Checkbox
